import { useCallback } from 'react';
import { useAiAssistantChat } from '../context/chat-context';

/**
 * Lightweight analogue of LibreChat's useSubmitMessage hook.
 * Provides submitMessage / submitPrompt wrappers that delegate to the chat context.
 */
export const useSubmitMessage = () => {
  const { sendMessage } = useAiAssistantChat();

  const submitMessage = useCallback(
    ({ text }: { text: string }) => {
      if (!text || !text.trim()) return;
      void sendMessage(text);
    },
    [sendMessage],
  );

  const submitPrompt = useCallback(
    (text: string) => {
      if (!text || !text.trim()) return;
      void sendMessage(text);
    },
    [sendMessage],
  );

  return { submitMessage, submitPrompt };
};
